import React from 'react';
import { Button } from './ui/button';
import { MessageCircle, Phone, Mail } from 'lucide-react';
import { finalCTA, companyInfo } from '../mockData';

const FinalCTA = () => {
  const handleWhatsAppClick = () => {
    // Facebook Pixel - Track Contact event
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'Contact', {
        content_name: 'Final CTA WhatsApp Click',
        content_category: 'WhatsApp'
      });
    }
    const message = encodeURIComponent(
      'Assalamualaikum. Saya telah membuat semakan awal melalui website dan ingin mendapatkan maklumat lanjut.'
    );
    window.open(`https://wa.me/${companyInfo.whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <section className="py-12 sm:py-16 bg-gradient-to-br from-emerald-800 via-emerald-900 to-emerald-950 relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-amber-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-amber-400 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Headline */}
          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            {finalCTA.headline}
          </h2>

          {/* Subheadline */}
          <p className="text-base sm:text-xl text-emerald-50 mb-8 sm:mb-10 leading-relaxed max-w-3xl mx-auto">
            {finalCTA.subheadline}
          </p>

          {/* CTA Button */}
          <Button
            size="lg"
            onClick={handleWhatsAppClick}
            data-testid="final-cta-whatsapp"
            className="bg-green-500 hover:bg-green-600 text-white font-bold text-base sm:text-xl px-8 sm:px-12 py-6 sm:py-8 rounded-lg shadow-2xl hover:shadow-green-500/50 hover:scale-105 transition-all duration-300 border-2 border-green-400 animate-pulse-cta"
          >
            <MessageCircle className="mr-2 sm:mr-3 h-5 w-5 sm:h-6 sm:w-6" />
            {finalCTA.buttonText}
          </Button>

          {/* Contact Info */}
          <div className="mt-10 sm:mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
            <a
              href={`tel:${companyInfo.phone}`}
              className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-md px-6 py-4 rounded-xl border border-amber-400/30 hover:bg-white/20 transition-all duration-300 hover:scale-105"
              data-testid="final-cta-phone"
            >
              <Phone className="h-5 w-5 text-amber-400" />
              <span className="text-white font-bold text-base sm:text-lg">{companyInfo.phoneFormatted}</span>
            </a>
            <a
              href={`mailto:${companyInfo.email}`}
              className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-md px-6 py-4 rounded-xl border border-amber-400/30 hover:bg-white/20 transition-all duration-300 hover:scale-105"
              data-testid="final-cta-email"
            >
              <Mail className="h-5 w-5 text-amber-400" />
              <span className="text-white font-medium text-sm sm:text-base break-all">{companyInfo.email}</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
